import React, { Component } from 'react'

export default class SuccessPayment extends Component {

    render() {
        return (
            <section className='pricing-area padding-top-100px padding-bottom-80px'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12 mt-3'>
                            <div className='success-payment'>
                                <div className='success-img'>
                                    <img src={'./assets/images/success-img.jpg'} />
                                </div>
                                <div className='success-head'>
                                    Your Job Subscription Payment was successfull
                                </div>
                                <div className='success-text'>
                                    Thanks you for purchasing featured job posting package . Your Transaction  ID ... You can start posting featured job posting now
                                    click here to login and start posting
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        )
    }
}
